import React, { useState, useEffect } from 'react'
import { Box, Divider, Typography } from '@mui/material';
import Grid from "@mui/material/Grid";
import InputControl from '../../Components/Common/TextField/TextField';
import CustomButton from '../../Components/Button/Button';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import CheckIcon from '@mui/icons-material/Check';
import Button from "@mui/material/Button";
import { useNavigate } from 'react-router-dom';
import { DeleteEmailTemplate, GetAllEmailTemplates } from '../../Reducers/dcoi';
import { useSelector, useDispatch } from 'react-redux';
import Spinner from '../../Components/Common/Spinner/Spinner';
import './ManageEmailTemplateHome.css';
import { Pagination } from '@mui/material';
import ConfirmationModel from '../../Components/Common/DeleteModel/DeleteModel';
import Toster from '../../Components/Common/Toster/Toster';

function ManageEmailTemplateHome() {
  const dispath = useDispatch();
  const { emailTemplatesList, inProgress } = useSelector(
    (state) => state.dcoi
  );

  const navigate = useNavigate();
  useEffect(() => {
    dispath(GetAllEmailTemplates())
  }, [dispath]);
  const [alert, setAlert] = useState(false);
  const [severity, setSeverity] = useState();
  const [message, setMessage] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredItems, setFilteredItems] = useState(emailTemplatesList);  // Store filtered items
  const [deleteModel, setDeleteModel] = useState(false);
  const [itemID, setItemID] = useState()  // Store filtered items
  const itemsPerPage = 20;

  useEffect(() => {
    if (emailTemplatesList?.length > 0) {
      setFilteredItems(emailTemplatesList); // Update filteredItems with the fetched data
    }
  }, [emailTemplatesList]);

  // Handle page change for pagination
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  // Handle search query change
  const handleSearchChange = (e) => {
    setSearchQuery(e);
  };

  // Perform search and filter items
  const handleSearchClick = () => {
    const filteredData = emailTemplatesList?.filter(item =>
      item?.Title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item?.Language?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item?.UserGroup?.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredItems(filteredData); // Update the filtered items state
    setCurrentPage(1); // Reset pagination to the first page
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem); // Slice filteredItems for pagination


  const SucessDelete = () => {
    dispath(DeleteEmailTemplate({ templateId: itemID })).then((res) => {

      if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
        setDeleteModel(!deleteModel);
        setAlert(true);
        setSeverity("success");
        setMessage(res?.payload?.data[0]?.success)
        dispath(GetAllEmailTemplates())
      } else if (res?.payload?.data[0]?.status === "error") {
        setAlert(true);
        setMessage(res?.payload?.data[0]?.error)
        setSeverity("error");
      } else {
        setAlert(true);
        setMessage("Something Went Wrong")
        setSeverity("error");
      }
    })
  }


  return (
    <>
      <Toster message={message} severity={severity} alert={alert} setAlert={setAlert} />
      <ConfirmationModel open={deleteModel} handleOpen={() => setDeleteModel(!deleteModel)} SucessDelete={SucessDelete} />
      <div className='headerNavigation'>
        <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>List of Email Template</Typography>
        <div></div>
      </div>
      <Box className='boxAlignment'>
        <Grid container spacing={2} alignItems="center" justifyContent="space-between">
          <Grid item xs={12} sm={12} md={6}>
            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
              <Box sx={{ flexGrow: 1 }}>
                <InputControl
                  type="text"
                  placeholder="Search by Name,Language Or Entity Admin Group.."
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </Box>
              <Button
                sx={{ backgroundColor: " #212129", color: "white", padding: "8px", borderRadius: "0px" }}
                startIcon={<SearchIcon className="actionIcon" />}
                onClick={handleSearchClick}
              >
              </Button>
            </Box>
          </Grid>
          <Grid item>
            <CustomButton onClick={() => {
              navigate('/app-dcoi/sitecontent/ManageEmailTemplate')
            }} label="+ ADD NEW TEMPLATE" />
          </Grid>
        </Grid>
        <Box sx={{ margin:"20px",overflowX: "auto", width: "100%"}}>
          <Box sx={{minWidth:"700px"}}>

          <Grid container my={2} spacing={2} alignItems="flex-start" sx={{ fontWeight: "bold", color: "gray"}} >
            <Grid item xs={4} sm={4} md={4}>EMAIL TEMPLATE NAME</Grid>
            <Grid item xs={2} sm={2} md={2}>LANGUAGE</Grid>
            <Grid item xs={3} sm={3} md={3}>ENTITY ADMIN GROUP</Grid>
            <Grid item xs={1} sm={1} md={1}>IN USE</Grid>
            <Grid item xs={2} sm={2} md={2}></Grid>
          </Grid>
          <Divider />
          {currentItems.length > 0 ? (
            currentItems.map((item, index) => (
              <React.Fragment key={index}>
                {/* Scrollable Wrapper Inside the Loop */}
                    <Grid container alignItems="flex-start" spacing={2} sx={{alignItems: "center",padding:"10px 0px" }}>
                      {/* Email Template Name */}
                      <Grid item xs={4} sm={4} md={4}>
                        <Typography>{item.Title}</Typography>
                      </Grid>

                      {/* Language */}
                      <Grid item xs={2} sm={2} md={2}>
                        <Typography>{item.Language}</Typography>
                      </Grid>

                      {/* Entity Admin Group */}
                      <Grid item xs={3} sm={3} md={3}>
                        <Typography>{item.UserGroup}</Typography>
                      </Grid>

                      {/* In Use */}
                      <Grid item xs={1} sm={1} md={1}>
                        <Typography>
                          {item.InUse===1 ? <CheckIcon color="success" /> : "--"}
                        </Typography>
                      </Grid>

                      {/* Actions - Desktop */}
                      <Grid item xs={2} sm={2} md={2} sx={{ display: { xs: "none", sm: "none", md: "flex" }, justifyContent: "right", cursor: "pointer" }}>
                        {item.InUse===0 && (
                          <Button className='actionButton' variant="contained" startIcon={<DeleteIcon className='actionIcon' />}
                            onClick={() => {
                              setItemID(item.ID);
                              setDeleteModel(!deleteModel);
                            }}>
                            Delete
                          </Button>
                        )}
                        &nbsp;&nbsp;
                        <Button className='actionButton' variant="contained" startIcon={<EditIcon className='actionIcon' />}
                          onClick={() => navigate('/app-dcoi/sitecontent/ManageEmailTemplate', { state: { emailData: item } })}>
                          Edit
                        </Button>
                      </Grid>

                      {/* Actions - Mobile */}
                      <Grid item xs={2} sm={2} md={2} sx={{ display: { xs: "flex", sm: "flex", md: "none" }, justifyContent: "right", cursor: "pointer" }}>
                        {item.InUse===0 && (
                          <DeleteIcon className='actionIconResponsive' onClick={() => {
                            setItemID(item.ID);
                            setDeleteModel(!deleteModel);
                          }} />
                        )}
                        &nbsp;&nbsp;
                        <EditIcon className='actionIconResponsive' onClick={() => navigate('/app-dcoi/sitecontent/ManageEmailTemplate', { state: { emailData: item } })} />
                      </Grid>
                    </Grid>
                <Divider />
              </React.Fragment>
            ))
          ) : (
            <>
              {(!inProgress && currentItems?.length === 0 )|| emailTemplatesList?.length === 0 ? (
                <Typography sx={{ margin: "20px", textAlign: "center", color: "gray", fontStyle: "italic" }}>
                  No Data Found...
                </Typography>
              ) : ""}
            </>
          )}

</Box>
        </Box>
        {currentItems?.length > 0 && <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Pagination showFirstButton showLastButton sx={{
            margin: "10px", padding: "5px", border: "1px solid  #212129",
            borderRadius: "20px"
          }} count={Math.ceil(filteredItems.length / itemsPerPage)} page={currentPage} onChange={handlePageChange} /></Box>}
      </Box>
      <Spinner isLoading={inProgress} />
    </>
  )
}

export default ManageEmailTemplateHome;
